import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { ReservationService } from '../../services/reservation.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { ProductosService } from '../../services/productos.service';
import { HostingService } from '../../services/hosting.service';
import { DetailComponent } from "./detail/detail.component";
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { AuthService } from '../../services/auth.service';

interface ProductoReserva {
  id: string;
  reservationId: string;
  productId: string;
  hotelId: string;
  name: string;
  quantity: number;
  unit_price: number;
  total_price: number;
  status: string; // "Pendiente" | "Pagado"
  created_at: string;
}

interface Stat {
  label: string;
  icon: string;
  value: string;
  sub: string;
}

 interface ReservationDetails {
  tipoAlojamiento: string;     // "Tipo de alojamiento"
  habitacion: {
    nombre: string;            // "Habitación"
    numero: number | string;   // "N°"
  };
  checkIn: Date | string;       // "Check-in"
  checkOut: Date | string;      // "Check-out"
  total: number;                // "Total"
}

@Component({
  selector: 'app-estadias',
  imports: [FormsModule, CommonModule, NavbarComponent, FooterComponent, DetailComponent],
  templateUrl: './estadias.component.html',
  styleUrl: './estadias.component.css'
})
export class EstadiasComponent {
  estadias: any[] = [];
  loading: boolean = false;
  error: string | null = null;
  alojamientos: any[] = [];
  alojamientosIds: string[] = [];
  reserva:ReservationDetails = {
  tipoAlojamiento: '',    
  habitacion: {
    nombre: '',           
    numero: '',  
  },
  checkIn: '',       
  checkOut:'',     
  total: 0               
}

  // Modal agregar productos
  mostrarModalAgregar: boolean = false;
  productosDisponibles: any[] = [];
  productosSeleccionados: { [key: string]: number } = {}; // productId -> cantidad
  estadiaSeleccionada: any = null;

  isLoading = true;


  showGuestsModal = false;
  isEditingGuests = false;
  originalGuests: any[] = [];

  // Cache para nombres de hoteles
  hotelNamesCache = new Map<string, string>();
   reservations: any[] = [];
  reservas: any[] = []; // Array transformado para la vista
  paginatedReservas: any[] = [];
  accommodations: any[] = [];

  // Estados
  is_loading = false;
  error_msg = '';
  searchTerm = '';

  // Paginación
  current_page = 0;
  page_size = 10;
  page_size_options = [5, 10, 20, 50];
  totalItems = 0;

  // Estadísticas
  stats: Stat[] = [
    { label: 'Total Reservas', icon: 'event', value: '0', sub: '' },
    { label: 'Confirmadas', icon: 'check_circle', value: '0', sub: '' },
    { label: 'Pendientes', icon: 'schedule', value: '0', sub: '' },
    { label: 'Ingresos', icon: 'payments', value: '$0', sub: '' }
  ];
  // Modal pagar productos
  pagarModalVisible: boolean = false;
  productosPendientes: ProductoReserva[] = [];
  loadingProductos: boolean = false;
  selectedPaymentMethod: string | null = null;

  // Modal finalizar estadía
  finalizarModalVisible: boolean = false;
  productosEstadia: ProductoReserva[] = [];
  loadingFinalizar: boolean = false;
  tienePendientes: boolean = false;

  constructor(
    private reservationService: ReservationService,
    private productosService: ProductosService,
 
    private readonly tokenStorage: TokenStorageService,
       private readonly  authService: AuthService,
  
        private readonly mercadoPagoService: MercadoPagoService,
        private readonly hostingService: HostingService,
       
  ) { 
   
  }

  ngOnInit() {
   // this.extraerAlojamientosDelToken();
    //this.cargarAlojamientosAsync().then(() => {
     // this.cargarEstadias();
    //});

    //this.cargarAlojamientos();
    
  }

   


   async cargarAlojamientos() {
    const data = await this.hostingService.getAllHostingIdRecepcion();
    this.alojamientos =data;
    console.log('Alojamients: ',this.alojamientos)
    this.cargarEstadias(this.alojamientos);
   }

  extraerAlojamientosUser() {
    this.loading = true;
    const user = this.tokenStorage.getUser();
    console.log('user', user?.attributes.sub);

  }


    extraerAlojamientosDelUsuario() {
      this.loading = true;
    const user = this.tokenStorage.getUser();
    console.log('user', user?.attributes);


    }

  extraerAlojamientosDelToken() {
    this.loading = true;
    const user = this.tokenStorage.getUser();
    console.log('user', user?.attributes);
    const alojamientosStr =
      user?.attributes?.['custom:alojamientos_ids'] ||
      user?.['custom:alojamientos_ids'] ||
      '';
    this.alojamientosIds = alojamientosStr
      ? alojamientosStr.split(',').map((id: string) => id.trim()).filter(Boolean)
      : [];
  }

  async cargarAlojamientosAsync() {
    try {
      const data = await this.hostingService.getHostingsByIds(this.alojamientosIds);
      this.alojamientos = data;
      console.log('[DEBUG] Alojamientos cargados:', this.alojamientos);
    } catch (err) {
      console.error('Error cargando alojamientos:', err);
    }
  }


   async loadReservations(alojamiento:string): Promise<void> {
    console.log('HOTEEEEEEEEEEEEEEEEEEEL mamaaaaaaaaaaaaaai',alojamiento)
  
    this.is_loading = true;
    this.error_msg = '';
    try {
      const token = this.tokenStorage.getAccessToken();
      const { user } = await this.authService.getUser();
      const response = await this.reservationService
        .getAllReservationsRecep({ page: this.current_page, limit: this.page_size, user_id: user?.id || '',alojamiento }, token)
        .toPromise();
      console.log("API response", response);
      this.reservations = response.data || [];
      this.totalItems = response.total;
      this.transformReservationsData();
      this.updatePagination();
      this.updateStats();
    } catch (err) {
      console.error(err);
      this.error_msg = 'Error loading reservations';
    } finally {
      this.is_loading = false;
    }
  }

    updatePagination(): void {
    const startIndex = this.current_page * this.page_size;
    const endIndex = startIndex + this.page_size;
    this.paginatedReservas = this.reservas.slice(startIndex, endIndex);

    console.log('Paginateeeeeeed', this.paginatedReservas)
  }

  private transformReservationsData(): void {
    this.reservas = this.reservations.map(reservation => ({
      id: reservation.id || reservation._id || '',
      accommodation: reservation.accommodation,
      accommodationName: reservation.accommodation.name,
      accommodationType: reservation.accommodation.type,
      room: reservation.room,
      roomtype: reservation.room.type,
      roomnumber:reservation.room.number,
      client: reservation.client,
      check_in: reservation.check_in ? new Date(reservation.check_in) : new Date(),
      check_out: reservation.check_out ? new Date(reservation.check_out) : new Date(),
      guests_detail: reservation.guests_detail,
      payment: reservation.payment,
      services: reservation.services || [],
      total: reservation.total_price || reservation.total || 0,
      status: this.mapEstado(reservation.status)
    }));
  }

  private mapEstado(status: string): 'Confirmada' | 'Pendiente' | 'Cancelada' | 'Completada' {
    const statusMap: { [key: string]: 'Confirmada' | 'Pendiente' | 'Cancelada' | 'Completada' } = {
      'confirmed': 'Confirmada',
      'confirmada': 'Confirmada',
      'pending': 'Pendiente',
      'pendiente': 'Pendiente',
      'cancelled': 'Cancelada',
      'cancelada': 'Cancelada',
      'completed': 'Completada',
      'completada': 'Completada'
    };

    return statusMap[status?.toLowerCase()] || 'Pendiente';
  }

  // ===== ACTUALIZACIÓN DE ESTADÍSTICAS =====
  private updateStats(): void {
    const total = this.reservas.length;
    const confirmadas = this.reservas.filter(r => r.status === 'Confirmada').length;
    const pendientes = this.reservas.filter(r => r.status === 'Pendiente').length;
    const totalIngresos = this.reservas
      .filter(r => r.status === 'Confirmada' || r.status === 'Completada')
      .reduce((sum, r) => sum + (r.total || 0), 0);

    this.stats[0].value = total.toString();
    this.stats[0].sub = `${total} reservas en total`;

    this.stats[1].value = confirmadas.toString();
    this.stats[1].sub = total > 0 ? `${Math.round((confirmadas / total) * 100)}% del total` : '0% del total';

    this.stats[2].value = pendientes.toString();
    this.stats[2].sub = pendientes > 0 ? 'Requieren atención' : 'Todo al día';

    this.stats[3].value = this.formatCurrency(totalIngresos);
    this.stats[3].sub = 'Ingresos totales';
  }


   formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

    onHostingSelectedFromDetail(hosting: any) {
    this.alojamientos = [hosting];
    this.loadReservations(this.alojamientos[0].id);
}

  cargarEstadias(alo :any) {
    this.error = null;
    const user = this.tokenStorage.getUser();
    console.log('user', user?.attributes);
    

const alojamientosStr = alo.map((alo:any) => alo.id).join(',');

    console.log('IDs alojamientos', alojamientosStr)
    this.reservationService
      .getStays(alojamientosStr, this.tokenStorage.getAccessToken() || '')
      .subscribe({
        next: (resp: any) => {
          const reservas = resp.estadias || [];

          this.estadias = reservas.map((res: any) => {
            const alojamiento = alo.find((alo:any) => alo.id === res.hotelId);

            // Buscar la habitación correspondiente dentro del array `rooms` si existe
            let room = null;
            if (Array.isArray(alojamiento?.rooms)) {
              room = alojamiento.rooms.find((r: any) => r.room_id === res.roomId);
            } else if (alojamiento?.room && alojamiento.room.room_id === res.roomId) {
              // Caso en que viene como objeto único
              room = alojamiento.room;
            }

            return {
              ...res,
              hotel_name: alojamiento?.name || res.hotelId,
              hotel_type: alojamiento?.type,
              room_name: room?.type || res.roomId,
              room_number: room?.number,
            };
          });

          this.loading = false;
          console.log('[DEBUG] Estadías enriquecidas:', this.estadias);
        },
        error: (err) => {
          this.error = 'No se pudo cargar el listado de estadías.';
          this.loading = false;
        },
      });
  }

  agregarProductos(estadia: any) {
    this.estadiaSeleccionada = estadia;
    this.mostrarModalAgregar = true;

    this.productosService.consultarProductosPorAlojamiento(estadia.hotelId, this.tokenStorage.getAccessToken() || '')
      .subscribe({
        next: (data) => {
          this.productosDisponibles = data.productos;
          this.productosSeleccionados = {};
        },
        error: (err) => {
          console.error('Error al cargar productos:', err);
        }
      });
  }

  cerrarModalAgregar() {
    this.mostrarModalAgregar = false;
    this.estadiaSeleccionada = null;
    this.productosDisponibles = [];
    this.productosSeleccionados = {};
  }

  confirmarAgregarProductos() {
    const seleccionados = Object.entries(this.productosSeleccionados)
      .filter(([_, cantidad]) => cantidad > 0)
      .map(([productId, cantidad]) => ({
        reservationId: this.estadiaSeleccionada.reservationId,
        productId,
        hotelId: this.estadiaSeleccionada.hotelId,
        quantity: cantidad
      }));

    if (seleccionados.length === 0) {
      alert("Selecciona al menos un producto con cantidad > 0");
      return;
    }

    this.reservationService.agregarProductosAEstadia(seleccionados, this.tokenStorage.getAccessToken() || '')
      .subscribe({
        next: () => {
          alert("Productos agregados correctamente");
          this.cerrarModalAgregar();
        },
        error: (err) => {
          console.error('Error al agregar productos:', err);
          alert("Error al agregar productos");
        }
      });
  }

  pagarProductos(estadia: any) {
    console.log(estadia)
    this.estadiaSeleccionada = estadia;
    this.pagarModalVisible = true;
    this.loadingProductos = true;

    this.reservationService.getProductosDeEstadia(
      estadia.id,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: (resp: any) => {
        this.productosPendientes = resp.productos.filter((p: ProductoReserva) => p.status === 'pendiente');
        this.loadingProductos = false;
      },
      error: (err) => {
        console.error('Error al cargar productos de la estadía:', err);
        this.loadingProductos = false;
      }
    });
  }

  confirmarPagoProductos() {
    if (!this.estadiaSeleccionada || !this.selectedPaymentMethod) return;

    const ids = this.productosPendientes.map(p => p.id);

    this.reservationService.pagarProductos(
      this.estadiaSeleccionada.reservationId,
      ids,
      this.selectedPaymentMethod,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: () => {
        this.productosPendientes = [];
        this.selectedPaymentMethod = null;
        this.cerrarModalPago();
      },
      error: (err) => {
        console.error('Error al pagar productos:', err);
      }
    });
  }

  cerrarModalPago() {
    this.pagarModalVisible = false;
    this.estadiaSeleccionada = null;
    this.productosPendientes = [];
  }

  abrirModalFinalizar(estadia: any) {
    this.estadiaSeleccionada = estadia;
    this.finalizarModalVisible = true;
    this.loadingFinalizar = true;

    this.reservationService.getProductosDeEstadia(
      estadia.reservationId,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: (resp: any) => {
        this.productosEstadia = resp.productos || [];
        this.tienePendientes = this.productosEstadia.some(p => p.status === 'pendiente');
        this.loadingFinalizar = false;
      },
      error: (err) => {
        console.error('Error al consultar productos de la estadía:', err);
        this.loadingFinalizar = false;
        alert('❌ Error al consultar productos de la estadía');
        this.cerrarModalFinalizar();
      }
    });
  }

  cerrarModalFinalizar() {
    this.finalizarModalVisible = false;
    this.estadiaSeleccionada = null;
    this.productosEstadia = [];
    this.tienePendientes = false;
  }

  confirmarFinalizarEstadia() {
    if (!this.estadiaSeleccionada) return;

    if (this.tienePendientes) {
      alert('⚠️ No se puede finalizar la estadía. Hay productos pendientes de pago.');
      return;
    }

    this.loadingFinalizar = true;

    this.reservationService.endStay(
      this.estadiaSeleccionada.reservationId,
      this.tokenStorage.getAccessToken() || ''
    ).subscribe({
      next: () => {
        this.loadingFinalizar = false;
        alert('✅ Estadía finalizada correctamente.');
        this.cerrarModalFinalizar();
        //this.cargarEstadias();
      },
      error: (err) => {
        console.error('Error al finalizar la estadía:', err);
        this.loadingFinalizar = false;
        alert('❌ No se pudo finalizar la estadía.');
      }
    });
  }
}
